const BasicDetails = () => {
    return (
        <div className="vision-card">
            <div id="basic">

                <h3 className="table-section-heading">
                    BASIC DETAILS
                </h3>

                <div className="table-section-wrap">
                    <table className="table-section basic-table">

                        <tbody>
                            <tr>
                                <th colSpan="4">
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            flexWrap: "wrap",
                                            width: "100%",
                                        }}
                                    >
                                        <span>BASIC DETAILS</span>

                                        <div style={{ textAlign: "right" }}>
                                            <div>09308-N J MISSION SCH PO KASIA KUSHINAGAR UP</div>
                                            <div>Date: 15-12-2016</div>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            <br />

                            <tr>
                                <td>SCHOOL NAME</td>
                                <td>NAV JEEVAN MISSION SCH PO KASIA KUSHINAGAR UP</td>
                                <td>SCHOOL CODE</td>
                                <td>09308</td>
                            </tr>

                            <tr>
                                <td>ADDRESS</td>
                                <td>NAV JEEVAN MISSION SCHOOL,,NAV JEEVAN NAGAR,SAPAHA ROAD PO KASIA</td>
                                <td>AFFILIATION CODE</td>
                                <td>2130499</td>
                            </tr>

                            <tr>
                                <td>PRINCIPAL</td>
                                <td>MR CYRIL COSTA</td>
                                <td>PRINCIPAL'S CONTACT NUMBER</td>
                                <td>9794190107</td>
                            </tr>

                            <tr>
                                <td>PRINCIPAL'S EMAIL ID</td>
                                <td>cyrilcosta.m@gmail.com</td>
                                <td>PRINCIPAL'S RETIREMENT DATE</td>
                                <td>30/04/2039</td>
                            </tr>

                            <tr>
                                <td>SCHOOL'S CONTACT NUMBER</td>
                                <td>0-9198269162</td>
                                <td>SCHOOL'S EMAIL ID</td>
                                <td>njms.kasia@gmail.com</td>
                            </tr>

                            <tr>
                                <td>SCHOOL'S WEBSITE</td>
                                <td>www.kasia.navjeevanschool.in</td>
                                <td>SCHOOL'S FAX NUMBER</td>
                                <td>0000000000</td>
                            </tr>

                            <tr>
                                <td>LANDMARK NEAR SCHOOL</td>
                                <td>near sapaha road</td>
                                <td>YEAR OF ESTABLISHMENT</td>
                                <td>1990</td>
                            </tr>

                            <tr>
                                <td>AFFILIATION VALIDITY</td>
                                <td>2002 TO 2018</td>
                                <td>AFFILIATION STATUS</td>
                                <td>PROVISIONAL</td>
                            </tr>

                            <tr>
                                <td>NAME OF THE TRUST / SOCIETY / COMPANY REGISTERED WITH</td>
                                <td>Nav Jeevan Mission Society Kasia</td>
                                <td>REGISTRATION DATE</td>
                                <td>18/06/1997</td>
                            </tr>

                            <tr>
                                <td>SOCIETY REGISTRATION NUMBER</td>
                                <td>2161/2014-2015</td>
                                <td>REGISTRATION VALIDITY</td>
                                <td>18/06/2017</td>
                            </tr>

                            <tr>
                                <td>NOC ISSUING AUTHORITY</td>
                                <td>Vishesh Karya Adhikari</td>
                                <td>NOC ISSUING DATE</td>
                                <td>17/01/2000</td>
                            </tr>

                            <tr>
                                <td>NO OBJECTION CERTIFICATE</td>
                                <td>VIEW</td>
                                <td>NON PROPRIETY CHARACTER AFFIDAVIT / NON PROFIT COMPANY AFFIDAVIT</td>
                                <td>VIEW</td>
                            </tr>
                        </tbody>

                    </table>
                </div>

            </div>
        </div>

    );
};

export default BasicDetails;